import { Button, Col, Image, Modal, Row, Select } from 'antd';
import { useCallback, useEffect, useState } from 'react';
import Webcam from 'react-webcam';

const WebcamModal = ({
  visible,
  closeModal,
  capture,
  webcamRef,
  imageSrc,
  resetImage,
  videoConstraints,
  method,
  selectMethod,
  countrySettings,
  countryCode,
}) => {
  const [deviceId, setDeviceId] = useState('');
  const [devices, setDevices] = useState([]);

  const handleDevices = useCallback(
    mediaDevices => {
      const filteredDevices = mediaDevices.filter(({ kind }) => kind === "videoinput")
      setDevices(filteredDevices)
      if (filteredDevices.length > 0) {
        setDeviceId(filteredDevices[0].deviceId);
      }
    }, [setDevices]);

  const changeDevice = (deviceId) => {
    setDeviceId(deviceId);
  }

  useEffect(() => {
    const getDevices = async () => {
      try {
        await navigator?.mediaDevices.getUserMedia({ video: true });

        const allDevices = await navigator?.mediaDevices.enumerateDevices();
        handleDevices(allDevices);
      } catch (err) {
        console.error("Error enumerando dispositivos u obteniendo permisos:", err);
        setDevices([]);
      }
    };
    getDevices();
  }, [handleDevices]);

  return (
    <Modal
      visible={visible}
      centered
      footer={false}
      closable
      onCancel={closeModal}
      className='webcam-modal'
      width={1000}
      responsive
      destroyOnClose
    >
      {
        !method ? (
          <Row align='middle' justify='center' className='pt-30 pb-30' gutter={[0, 40]}>
            <Col
              span={24}
              className='text-center'
            >
              <h2>Selecciona el método para tomar la foto</h2>
            </Col>
            <Col
              xl={8}
              lg={12}
              md={16}
              xs={24}
            >
              <Row
                align='middle'
                justify="space-between"
              >
                <Col span={countrySettings.patientForm.TOCWebcamButton[countryCode] ? 12 : 24}>
                  <Button
                    type="primary"
                    className="cmt-button secondary"
                    size="large"
                    onClick={() => selectMethod('webcam')}
                  >
                    Usar webcam
                  </Button>
                </Col>
                {
                  countrySettings.patientForm.TOCWebcamButton[countryCode] &&
                  <Col span={12}>
                    <Button
                      type="primary"
                      className="cmt-button secondary outline"
                      size="large"
                      onClick={() => selectMethod('toc')}
                    >
                      Usar TOC
                    </Button>
                  </Col>
                }
              </Row>
            </Col>
          </Row>
        ) :
          (
            <Row
              align='middle'
              justify='center'
              className='pt-30 pb-30'
              gutter={[0, 30]}
            >
              <Col
                lg={24}
                xs={24}
                className='text-center mt-50 mb-20'
              >
                {
                  imageSrc && !imageSrc.includes('missing') ? (
                    <Image
                      src={imageSrc}
                      alt='patient'
                      style={{ width: 276, height: 284 }}
                    />
                  ) :
                    <Webcam
                      audio={false}
                      height={360}
                      ref={webcamRef}
                      screenshotFormat="image/png"
                      width={640}
                      videoConstraints={{ ...videoConstraints, deviceId }}
                    />
                }
              </Col>
              <Col
                xl={7}
                lg={7}
                xs={24}
              >
                <Row>
                  {!(imageSrc && !imageSrc.includes('missing')) && (
                    <Col span={24}>
                      <Select
                        className='cmt-select mb-20'
                        value={deviceId}
                        onChange={changeDevice}
                        placeholder='Seleccione una cámara'
                        size="middle"
                        options={devices?.map((device) => ({ label: device.label, value: device.deviceId }))}
                      />
                    </Col>)}
                  <Col span={24}>
                    <Button
                      type="primary"
                      className="cmt-button primary mb-20"
                      size="large"
                      onClick={capture}
                    >
                      {
                        imageSrc && !imageSrc.includes('missing') ? 'Guardar foto' : 'Tomar foto'
                      }
                    </Button>
                  </Col>
                  {
                    imageSrc && !imageSrc.includes('missing') && (
                      <Col
                        span={24}
                      >
                        <Button
                          className="cmt-button primary outline"
                          type="primary"
                          size="large"
                          onClick={resetImage}
                        >
                          Borrar foto
                        </Button>
                      </Col>
                    )
                  }
                </Row>
              </Col>
            </Row>
          )
      }
    </Modal>
  );
};

export default WebcamModal;
